import EmblaCarousel from 'embla-carousel'
import Autoplay from 'embla-carousel-autoplay'
import ClassNames from 'embla-carousel-class-names'
import Fade from 'embla-carousel-fade'

window.addEventListener('load', function() {
    
    const blocks = document.querySelectorAll('.hoyry-testimonials-block')
    
    blocks.forEach(block => {
        
        const viewportNode = block.querySelector('.embla__viewport')
        if (!viewportNode || !viewportNode.children.length) return;
        
        const prevBtn = block.querySelector('.embla__button--prev')
        const nextBtn = block.querySelector('.embla__button--next')
        const dotsNode = block.querySelector('.embla__dots')
        
        const dataAnimation = block.dataset.animation
        const dataDelay = parseInt(block.dataset.delay) * 1000
        
        const OPTIONS = {
            loop: true,
            duration: dataAnimation === 'fade' ? 30 : 23,
        }
        
        const emblaApi = EmblaCarousel(viewportNode, OPTIONS, [
            Autoplay({ playOnInit: true, delay: dataDelay }),
            ClassNames(),
            dataAnimation === 'fade' ? Fade() : undefined,
        ].filter(Boolean))
        
        const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
            emblaApi,
            prevBtn,
            nextBtn,
            emblaApi.plugins().autoplay
        )
        const removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(
            emblaApi,
            dotsNode,
            emblaApi.plugins().autoplay
        )
        emblaApi
            .on('destroy', removePrevNextBtnsClickHandlers)
            .on('destroy', removeDotBtnsAndClickHandlers)
        
    })
    
})

const addTogglePrevNextBtnsActive = (emblaApi, prevBtn, nextBtn) => {
    const togglePrevNextBtnsState = () => {
    if (emblaApi.canScrollPrev()) prevBtn.removeAttribute('disabled')
    else prevBtn.setAttribute('disabled', 'disabled')
    if (emblaApi.canScrollNext()) nextBtn.removeAttribute('disabled')
    else nextBtn.setAttribute('disabled', 'disabled')
}

emblaApi
    .on('select', togglePrevNextBtnsState)
    .on('init', togglePrevNextBtnsState)
    .on('reInit', togglePrevNextBtnsState)
    return () => {
        prevBtn.removeAttribute('disabled')
        nextBtn.removeAttribute('disabled')
    }
}
  
export const addPrevNextBtnsClickHandlers = (emblaApi, prevBtn, nextBtn, autoplayPlugin) => {
    if (!prevBtn || !nextBtn || emblaApi.scrollSnapList().length <= 1) {
        return () => {}
    }
    
    const scrollPrev = () => { 
        emblaApi.scrollPrev()
        autoplayPlugin?.reset()
    }
    const scrollNext = () => { 
        emblaApi.scrollNext()
        autoplayPlugin?.reset()
    }
    
    prevBtn.addEventListener('click', scrollPrev, false)
    nextBtn.addEventListener('click', scrollNext, false)
    
    const removeTogglePrevNextBtnsActive = addTogglePrevNextBtnsActive(
        emblaApi,
        prevBtn,
        nextBtn
    )
    
    return () => {
        removeTogglePrevNextBtnsActive()
        prevBtn.removeEventListener('click', scrollPrev, false)
        nextBtn.removeEventListener('click', scrollNext, false)
    }
    
}

export const addDotBtnsAndClickHandlers = (emblaApi, dotsNode, autoplayPlugin) => {
    if (!dotsNode || emblaApi.scrollSnapList().length <= 1) {
        return () => {}
    }
    
    let dotNodes = []
    
    const addDotBtnsWithClickHandlers = () => {
        dotsNode.innerHTML = emblaApi
            .scrollSnapList()
            .map(() => '<button class="hoyry-testimonials-dot embla__dot" type="button"></button>')
            .join('')
        const scrollTo = (index) => {
            emblaApi.scrollTo(index)
            autoplayPlugin?.reset()
        }
        dotNodes = Array.from(dotsNode.querySelectorAll('.embla__dot'))
        dotNodes.forEach((dotNode, index) => {
            dotNode.addEventListener('click', () => scrollTo(index), false)
        })
    }
    
    const toggleDotBtnsActive = () => {
        if (!dotNodes.length) return
        const previous = emblaApi.previousScrollSnap()
        const selected = emblaApi.selectedScrollSnap()
        dotNodes[previous]?.classList?.remove('embla__dot--selected')
        dotNodes[selected]?.classList?.add('embla__dot--selected')
    }
    
    emblaApi
        .on('init', addDotBtnsWithClickHandlers)
        .on('reInit', addDotBtnsWithClickHandlers)
        .on('init', toggleDotBtnsActive)
        .on('reInit', toggleDotBtnsActive)
        .on('select', toggleDotBtnsActive)
    
    return () => {
        dotsNode.innerHTML = ''
    }
    
}